module.exports = __webpack_public_path__ + "img/no.197938eb.svg";